import styled from 'styled-components';

export const _Fieldset = styled.fieldset`
  border: none;
  padding: none;
  margin-top: 16px;
  margin-bottom: 20px;
  padding: 0;

  + div > #tacCheckbox {
    margin-bottom: 8px
  }
`;

export const _Legend = styled.legend`
  font-family: aktiv-grotesk, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: ${(props) => props.theme.black};
  padding: 0;
  margin-bottom: 8px;
`;
